import * as UpChunk from '@mux/upchunk/dist/upchunk';

window.addEventListener('load', function () {
  const file_input = document.getElementById('video_file');

  if (file_input) {
    file_input.addEventListener('change', (event)=>{
      const direct_upload_url = document.getElementById('direct_upload_url').innerText;
      const upload = UpChunk.createUpload({
        endpoint: direct_upload_url,
        file: event.target.files[0],
        chunkSize: 5120, // Uploads the file in ~5mb chunks
      });

      document.getElementById('my_progress').style.display = "block";
      document.getElementById('my_bar').style.display = "block";
      file_input.disabled = true;
      
      upload.on('error', err => {
        file_input.disabled = false;
        document.getElementById('my_bar').style.width = "1%";
        // TODO: show errors details
      });
      
      upload.on('progress', progress => {
        document.getElementById('my_bar').style.width = progress.detail + "%";
      });
      
      upload.on('success', err => {
        document.getElementById('create_link').click();
      }); 
    })
  }
})